var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"pages-content-scroll"},[_c('el-backtop',{attrs:{"visibility-height":_vm.visibleHeight,"right":_vm.rightPos,"bottom":_vm.bottomPos}},[_c('img',{attrs:{"src":require("../assets/icon_top.svg"),"alt":""}}),_c('p',[_vm._v("回到顶部")])]),_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }